import { Globals } from "../CoreApp/Globals";
import { QCheckForUpdatesRFC } from "../CoreApp/QCheckForUpdatesRFC";

export function PollForPlanChanges(repeat) {
  var wsMgr = Globals._wsMgr;
  var planMgr = wsMgr.fPlanManager;
  if (planMgr == null) return;

  var accountName = wsMgr.GetAccountName();
  var user = wsMgr.GetUserName();
  if (wsMgr.fCanvasPanel && wsMgr.fCanvasPanel.IsShown()) {
    /*
			Need to be careful here. QCheckForUpdatesRFC can send an additional RFC as a part of DoTransactionComplete
			that will delay the completion of the poll until the subsequent request is handled. However, qquerysvrchart RFCs
			in planning will not stack. In any event, we are only interested in checking for a stale state if there are
			no pending calls that could be in the process of updating the frontend.
		*/
    if (Globals._rfcMgr.QueueSize() < 1) {
      var loadOverridesRFC = new QCheckForUpdatesRFC();
      loadOverridesRFC.InitCheckForUpdates(planMgr);
      loadOverridesRFC.SetParams(accountName, user, planMgr.GetPlanID());
      Globals._rfcMgr.QueueRFC(loadOverridesRFC);
    }
  }
  var timeout = planMgr.GetPlanStatus() === "Active" ? 4000 : 50000;
  if (repeat)
    planMgr.fPollListener = setTimeout(function () {
      PollForPlanChanges(repeat);
    }, timeout);
}
